import { UrlSegment } from '@angular/router';

/**
 * see Angular UrlSegment parameters [doc](https://angular.io/api/router/UrlSegment#parameters)
 */
export class BreadcrumbUrl {
  public readonly urlString: string;
  public readonly urlPath: string;

  constructor(public readonly segments: UrlSegment[] = []) {
    this.urlString = this.segments.reduce(
      (acc, segment) =>
        `${acc}/${encodeURIComponent(segment.path)}${
          Object.keys(segment.parameters).length ? '?' + this.serializeSegmentParams(segment.parameters) : ''
        }`,
      ''
    );

    this.urlPath = this.urlString;
  }

  private serializeSegmentParams(params: Record<string, string>): string {
    return Object.entries(params)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&');
  }
}
